/** Query parameter of the photo-download page that carries a signed SAS URL — a bearer token. */
export const PHOTO_DOWNLOAD_SECRET_PARAM = 'file';

/** The only photo-download query parameters any log may keep (an allowlist, so a new secret is dropped). */
export const PHOTO_DOWNLOAD_LOGGED_PARAMS: ReadonlyArray<string> = ['audience'];

// Sub-paths too: the page only renders on the exact path, but a crafted `/photo-download/x?file=…`
// falls through to the guest site and must still be redacted. `[\s\S]`: decodeURI turns %0A into a newline.
const PHOTO_DOWNLOAD_PATH = /^\/[^/]+\/photo-download(?:\/[\s\S]*)?$/;

const decodeOrRaw = (path: string): string => {
  try {
    return decodeURI(path);
  } catch {
    // Fail closed: an undecodable path is still matched (raw), so its error log can't carry the token.
    return path;
  }
};

/**
 * True for `/:eventHandle/photo-download` (and sub-paths), matched the way the client router sees it
 * (decodeURI'd, case-insensitive, slash-tolerant) so `photo%2Ddownload` can't skip redaction.
 */
export const isPhotoDownloadPath = (path: string): boolean => PHOTO_DOWNLOAD_PATH.test(decodeOrRaw(path).toLowerCase().replace(/^\/+/, '/').replace(/\/+$/, ''));

/** On the photo-download page, the query reduced to `PHOTO_DOWNLOAD_LOGGED_PARAMS`; any other query as-is. */
export const loggablePhotoDownloadQuery = <TQuery extends Record<string, unknown>>(path: string, query: TQuery): Partial<TQuery> => {
  if (!isPhotoDownloadPath(path)) {
    return query;
  }
  return Object.fromEntries(Object.entries(query).filter(([name]) => PHOTO_DOWNLOAD_LOGGED_PARAMS.includes(name))) as Partial<TQuery>;
};
